var React = require('react');

function IcLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 9H7C5.35 9 4 10.35 4 12C4 13.65 5.35 15 7 15H11V17H7C4.24 17 2 14.76 2 12C2 9.24 4.24 7 7 7H11V9ZM17 7C19.76 7 22 9.24 22 12C22 14.76 19.76 17 17 17H13V15H17C18.65 15 20 13.65 20 12C20 10.35 18.65 9 17 9H13V7H17ZM16 13H8V11H16V13Z","fill":"currentColor"}));
}

IcLink.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcLink;

IcLink.default = IcLink;
